import { cn } from '@/utils/helpers';

/**
 * Card component for content containers
 */
function Card({ 
  children, 
  className, 
  hover = false,
  padding = true,
  ...props 
}) {
  return (
    <div 
      className={cn(
        'bg-white rounded-xl shadow-sm border border-gray-100',
        hover && 'transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 cursor-pointer',
        padding && 'p-6',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

/**
 * Card Header component
 */
Card.Header = function CardHeader({ children, className }) {
  return (
    <div className={cn('mb-4', className)}>
      {children}
    </div>
  );
};

/**
 * Card Title component
 */
Card.Title = function CardTitle({ children, className }) {
  return (
    <h3 className={cn('text-lg font-semibold text-gray-900', className)}>
      {children}
    </h3>
  );
};

/**
 * Card Description component
 */
Card.Description = function CardDescription({ children, className }) {
  return (
    <p className={cn('text-sm text-gray-500 mt-1', className)}>
      {children}
    </p>
  );
};

/**
 * Card Content component
 */
Card.Content = function CardContent({ children, className }) {
  return (
    <div className={cn('', className)}>
      {children}
    </div>
  );
};

/**
 * Card Footer component
 */
Card.Footer = function CardFooter({ children, className }) {
  return (
    <div className={cn('mt-4 pt-4 border-t border-gray-100', className)}>
      {children}
    </div>
  );
};

export default Card;
